export const GET_CASES = "GET_CASES";
export const GET_CLOSED_CASES ="GET_CLOSED_CASES";
export const GET_USER_CASES = "GET_USER_CASES";
export const SET_END_OF_USER_TICKETS = "SET_END_OF_USER_TICKETS";